import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { AgentOptions } from '@newrelic/browser-agent/loaders/agent'

declare global {
  interface Window {
    __NR_AGENT__?: BrowserAgent;
  }
}

function getAgent(): BrowserAgent | null {
  return window.__NR_AGENT__ ?? null;
}

function setAgent(browserAgent: BrowserAgent): void {
  window.__NR_AGENT__ = browserAgent;
}

export function initNewRelic(options: AgentOptions): BrowserAgent {
  const existingAgent = getAgent();
  if (existingAgent) {
    return existingAgent;
  }

  const newAgent = new BrowserAgent(options);
  setAgent(newAgent);
  newAgent.start();

  return newAgent;
}

export function getNewRelicAgent(): BrowserAgent | null {
  return getAgent();
}
